import app from './app';
import filters from './filters';
import tippy from 'tippy.js';
import propertyPhotosSlider from './propertyPhotosSlider';
import mapMenuSpacer from './mapMenuSpacer';
import modalCityLabelOpacity from './modalCityLabelOpacity';
import 'tippy.js/dist/tippy.css';
import closeButtonWebviewMessenger from './closeButtonWebviewMessenger';

// app
// TODO: temporal workaround for translations, until provide a better solution
setTimeout(() => {
  filters(window);
  propertyPhotosSlider(window);
  mapMenuSpacer(window);
  modalCityLabelOpacity(window);
  tippy('[data-tippy-content]', { zIndex: 12001 });
  closeButtonWebviewMessenger(window);

  window.addEventListener('map:reload', _ => app(window));
});
